/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoteParticipantDto } from '../models/RemoteParticipantDto';
import type { RemoteParticipantFilterResponseDto } from '../models/RemoteParticipantFilterResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteParticipantControllerService {

    /**
     * @param healthStatus
     * @param from
     * @param status
     * @param limit
     * @param name
     * @returns RemoteParticipantFilterResponseDto OK
     * @throws ApiError
     */
    public static listRemoteParticipants(
        healthStatus?: boolean,
        from?: number,
        status?: 'COMPLETED' | 'PENDING' | 'RUNNING',
        limit?: number,
        name?: string,
    ): CancelablePromise<RemoteParticipantFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-participants',
            query: {
                'healthStatus': healthStatus,
                'from': from,
                'status': status,
                'limit': limit,
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateRemoteParticipant(
        requestBody: RemoteParticipantDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/remote-participants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns RemoteParticipantDto Created
     * @throws ApiError
     */
    public static createRemoteParticipant(
        requestBody: RemoteParticipantDto,
    ): CancelablePromise<RemoteParticipantDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remote-participants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns RemoteParticipantDto OK
     * @throws ApiError
     */
    public static getRemoteParticipant(
        name: string,
    ): CancelablePromise<RemoteParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-participants/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteRemoteParticipant(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/remote-participants/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
